import React, { Fragment } from 'react'
import { Grid, Paper, Icon, Typography } from '@material-ui/core';


export default function StatusBookingPayment(props) {

    const {idTransaction, content} = props

    return (
        <Fragment>
            <div className="info-status-reserva">
                <div className="bloq-estados-transaccion">
                    
                    <div className="num-transaccion">
                        <Grid container>
                            <Grid item xs={6}>
                                <Typography className="title text-left">Código de reserva</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <div className="number">
                                    <Typography className="sonataid">{idTransaction}</Typography>
                                </div>
                            </Grid>
                        </Grid>
                    </div>

                    {content.status_booking &&
                        <div className="estado-reserva">
                            <Grid container>
                                <Grid item xs={6}>
                                    <Typography className="title text-left">Estado de reserva:</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography className="estado">
                                        <Icon className="status_booking_icon">{content.status_booking_icon}</Icon> <span className="texto">
                                            {content.status_booking}</span>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </div>
                    }

                    {content.status_payment && 
                        <div className="estado-pago">
                            <Grid container>
                                <Grid item xs={6}>
                                    <Typography className="title text-left">Estado de pago:</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography className="estado">
                                        <Icon className="status_payment_icon">{content.status_payment_icon}</Icon> <span>
                                            {content.status_payment}</span>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </div>
                    }

                </div>
            </div>
            {content.messages && content.messages.length > 0 &&
                <Paper className="block-info info-pasajeros mb-2" variant="outlined">
                    <div className="block-info-container MuiPaper-rounded">
                        <div className="col-icono">
                            <Icon>info</Icon>
                        </div>
                        <div className="col-texto">
                            {content.messages.map((message, id) => 
                            <Typography key={id} className="message">{message.item}</Typography>
                            )} 
                        </div>
                    </div>
                </Paper>
            }
    </Fragment>
    )
}
